@if (($safeNavigationMigration(this.rsvpDisplay?.isLoading$) | async) === true) {
  <app-loading-spinner-overlay [isLoading]="true" [screenReaderText]="'Sending Pre-Registration for event.'">
  </app-loading-spinner-overlay>
}

@if (this.rsvpDisplay; as display) {
  @if (this.rsvpDisplay.publicMeeting$ | async; as meeting) {
    <!-- RSVP Form -->
    <div class="container">
      <h1>
        @if (meeting.MeetingName) {
          <span> {{ meeting.ProjectName }}: Pre-Registration </span>
        } @else {
          Project Name
        }
      </h1>
      <h3>
        @if (meeting.MeetingName) {
          <span> Pre-Register for {{ meeting.MeetingName }} </span>
        }
      </h3>
      <div class="info-text">
        <p>Please enter your information to pre-register for the meeting.</p>
      </div>
      <app-global-search-stakeholder
        (formResult)="handleStakeholderSearchResult($event, meeting, display)"
        (formValidity)="handleFormValidity($event)"
        [emitOnSubmit]="onStakeholderSearch"
        [removeOnBlur]="true"
      ></app-global-search-stakeholder>
      <form class="rsvp-form" [formGroup]="this.rsvpDisplay.fg">
        <mat-form-field appearance="fill">
          <mat-label for="rsvpPeopleCount">How many people are in your group, total?</mat-label>
          <input
            #rsvpPeopleCount
            matInput
            type="number"
            pattern="^\d$"
            [formControl]="this.rsvpDisplay.controls.peopleCount"
          />
          <mat-hint align="end">Must have at least <i>1</i> attendee.</mat-hint>
        </mat-form-field>
        <div class="button-container">
          <button
            [disabled]="
              !this.isStakeholderSearchValid ||
              !!this.rsvpDisplay.fg.invalid ||
              !!this.rsvpDisplay.fg.errors ||
              (this.rsvpDisplay.isLoading$ | async) ||
              (this.isPostInProgress$ | async)
            "
            (click)="this.onRsvpClicked()"
            class="blue-button"
          >
            Submit
            @if ((this.rsvpDisplay.isLoading$ | async) || (this.isPostInProgress$ | async)) {
              <mat-spinner [diameter]="16" [mode]="'indeterminate'"> </mat-spinner>
            }
          </button>
        </div>
      </form>
    </div>
    <!-- RSVP Form End -->
  } @else {
    @if ((this.rsvpDisplay.isLoading$ | async) === false) {
      <p class="error-message">Unable to find the meeting</p>
    }
  }
} @else {
  @if (($safeNavigationMigration(this.rsvpDisplay?.isLoading$) | async) === false) {
    <p class="error-message">Unable to find the meeting</p>
  }
}
